import { TeamsMsal2Provider } from "@microsoft/mgt-teams-msal2-provider";

export default function TeamsAuthPopup(): JSX.Element {
  TeamsMsal2Provider.handleAuth();
  return <div>Authenticating. Please wait.</div>;
}
 